/* header-vexial.js — lógica de sections/header-vexial.liquid.

   Extraído del <script> inline (O1): el header se renderiza en TODAS las
   páginas, así que inline se re-descargaba en cada navegación. Se carga con
   defer; nada de acá corre antes del parseo del documento.

   CICLO DE VIDA — importante si vienes del inline:
   inline, este código se re-ejecutaba solo cada vez que el editor de temas
   re-renderizaba la sección. Como asset externo eso ya no pasa (el navegador
   no re-ejecuta un script que ya cargó), así que el re-init es explícito, vía
   shopify:section:load. Y con re-init, limpiar los listeners globales dejó de
   ser opcional: cada corrida ata los suyos a un AbortController propio y
   aborta el de la corrida anterior.
*/

/* ════════════════════════════════════════════════════════════════
   VEXiAL Header JS — v2
   Todos los fixes aplicados. Ver comentario al inicio del archivo.
   ════════════════════════════════════════════════════════════════ */
/* Toda la lógica vive acá dentro para poder re-inicializarla. El nombre va
   con prefijo vxh porque este archivo es un script clásico y la declaración
   queda en el ámbito global. */
function vxhInitHeader() {
  'use strict';

  /* ── Ciclo de vida de esta instancia ──────────────────────────
     Aborta los listeners globales de la corrida anterior antes de
     registrar los suyos. Sin esto, cada re-render del editor los
     duplicaría — el problema que outsideClickClosers (más abajo)
     resolvía solo a medias. */
  if (window.__vxhHeaderAbort) window.__vxhHeaderAbort.abort();
  var __vxhAC = new AbortController();
  window.__vxhHeaderAbort = __vxhAC;

  /* Registra un listener global atado a esta instancia. Misma firma que
     addEventListener, con el target como primer argumento. En navegadores
     sin soporte de `signal` la opción se ignora y el listener igual queda
     registrado: degrada a lo que hacía antes. */
  function on(target, type, handler, opts) {
    var o = (typeof opts === 'boolean') ? { capture: opts } : Object.assign({}, opts);
    o.signal = __vxhAC.signal;
    target.addEventListener(type, handler, o);
  }

  /* ─── Helpers ──────────────────────────────────────────────── */
  function escHtml(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* FIX: hasTag hace match EXACTO de un tag, no substring.
     indexOf('producto-fisico') sobre un string tambien hace match
     con 'producto-fisico-relacionado' o similares -- eso causaba
     que productos SIN el tag exacto se marcaran como fisico. */
  function hasTag(tagsRaw, tagName) {
    var list = Array.isArray(tagsRaw) ? tagsRaw : String(tagsRaw || '').split(',');
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]).trim().toLowerCase() === tagName) return true;
    }
    return false;
  }

  /* Formatos (DXF, PDF, etc.) vienen de tags agregados sin prefijo,
     mismo criterio que en las tarjetas del megamenu. Se extraen de
     los mismos tags que ya se leen para hasTag(), sin necesitar un
     data-formats aparte. */
  var VXH_KNOWN_FORMATS = ['PDF', 'DXF', 'MP4', 'IGS', 'JPG', 'SVG'];
  function extractFormats(tagsRaw) {
    var list = Array.isArray(tagsRaw) ? tagsRaw : String(tagsRaw || '').split(',');
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var t = String(list[i]).trim().toUpperCase();
      if (VXH_KNOWN_FORMATS.indexOf(t) > -1) out.push(t);
    }
    return out;
  }

  /* Los widgets de Judge.me pueden quedar sin hidratar si estaban
     ocultos (display:none) cuando su script hizo el escaneo inicial
     de la pagina -- exactamente el caso del megamenu, oculto hasta
     que se pasa el cursor, y de los resultados del buscador,
     insertados recien al abrir. Forzamos un re-render en ambos
     momentos. No-op si la API no existe con ese nombre. */
  function refreshReviewWidgets() {
    if (window.jdgm && typeof window.jdgm.batchRenderBadges === 'function') {
      try { window.jdgm.batchRenderBadges(); } catch (e) {}
    }
  }

  /**
   * /search/suggest.json devuelve los precios en decimal (52.0 para
   * $52.00), no en centavos como /cart.js. El formato lo pone
   * assets/vx-money.js, que es el unico sitio del tema que arma dinero
   * en JS; antes esta funcion escribia "$52.00" sin la moneda y no
   * coincidia con ninguna otra superficie.
   *
   * Shopify.formatMoney no existe en esta tienda (comprobado en el
   * storefront), asi que la rama que lo intentaba nunca corria.
   */
  function fmtMoney(v) {
    if (!window.VXMoney || !isFinite(parseFloat(v))) return '';
    /* Con la moneda encendida el precio lleva también el sol, convertido y
       con «≈» delante: /products.json y /search/suggest.json no traen el
       precio en soles fijado a mano, así que aquí no puede ser la cifra
       exacta de la ficha (MONEDA.md §5). Apagada, VXMoney.html devuelve el
       mismo texto que fromDecimal, sin marcado. */
    return VXMoney.html(VXMoney.toCents(v), { aprox: true });
  }

  /* ─── Spacer unificado + scroll mobile ─────────────────────
     Un solo spacer (#vxh-spacer) insertado como firstChild del
     page-wrapper compensa el header fijo en ambos breakpoints.

     Desktop (≥990px):
       height = altura total de .vexial-header-section (F1 + F2).

     Mobile (≤989px):
       · Al inicio: height = mobile-bar(56px) + buscador(~54px).
       · Al hacer scroll hacia abajo: mobile-bar colapsa a 0,
         spacer se reduce a solo la altura del buscador.
       · Al volver al top (y ≤ 8): mobile-bar reaparece, spacer
         vuelve a la altura total.

     La medición del spacer se hace SIEMPRE con valores explícitos
     (no offsetHeight del topbar durante transición) para evitar
     lecturas incorrectas mientras la animación está en curso.
     ─────────────────────────────────────────────────────────── */
  var headerSection = document.querySelector('.vexial-header-section');
  var mobileTopbar  = document.getElementById('vxh-mobile-topbar');
  var mobileBar     = document.querySelector('.vxh-mobile-bar');
  var mobileSearch  = document.querySelector('.vxh-mobile-search');

  /* Un solo spacer para todo */
  var pw = document.querySelector('.page-wrapper');
  /* scroll container confirmado por diagnóstico — compartido por desktop y mobile */
  var _pwScroll = pw || null;
  var spacer = document.getElementById('vxh-spacer');
  if (!spacer) {
    spacer = document.createElement('div');
    spacer.id = 'vxh-spacer';
    spacer.style.cssText = 'flex-shrink:0;width:100%;pointer-events:none;';
    if (pw) {
      pw.insertBefore(spacer, pw.firstChild);
    } else if (headerSection) {
      headerSection.parentNode.insertBefore(spacer, headerSection.nextSibling);
    }
  }

  var mBarHidden = false;

  /* La altura de la barra mobile vive en --vxh-mbar-h (CSS). Se lee de ahí
     para no repetir el número entre CSS y JS; el fallback cubre el caso de
     que la variable no esté definida. */
  var MOBILE_BAR_H = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--vxh-mbar-h'), 10
  ) || 56;

  function adjustSpacer() {
    if (window.innerWidth >= 990) {
      /* Desktop: spacer = altura total del header (F1 + F2), nunca cambia */
      spacer.style.height = (headerSection ? headerSection.offsetHeight : 0) + 'px';
    } else {
      /* Mobile: spacer = topbar(56px) + buscador.
         El buscador siempre es visible, el topbar puede ocultarse
         pero el spacer no cambia — el contenido no se mueve nunca */
      var searchH = mobileSearch ? mobileSearch.offsetHeight : 54;
      spacer.style.height = (MOBILE_BAR_H + searchH) + 'px';
    }
  }

  /* Aplicar spacer al inicio — setTimeout asegura que el DOM
     está completamente pintado antes de medir alturas */
  setTimeout(adjustSpacer, 0);
  var _resizeT;
  on(window, 'resize', function () {
    clearTimeout(_resizeT);
    _resizeT = setTimeout(adjustSpacer, 100);
  }, { passive: true });

  /* ── Scroll mobile: oculta/muestra mobile-bar ─────────────
     Detección independiente del scroll container para mobile.
     En mobile el scroll puede estar en page-wrapper, window,
     document.documentElement o document.body según el dispositivo.
     ─────────────────────────────────────────────────────── */
  if (mobileBar) {

    var mLastY   = 0;
    var mTicking = false;

    /* O7: leer SIEMPRE de una sola fuente. Antes se probaban cinco y se
       devolvía la primera >0, así que mLastY podía comparar lecturas de
       contenedores distintos y confundir la dirección del scroll.

       La fuente se elige por si el contenedor REALMENTE scrollea, no por si
       existe: .page-wrapper solo tiene overflow-y:auto en @media (min-width:990px),
       así que en mobile existe pero no scrollea — ahí el scroller es el
       documento. Medido en el preview a 375px: page-wrapper.scrollTop 0 con
       overflow visible, contra window.scrollY 800.

       (getScrollY(), su gemela de desktop, se queda con el `if (_pwScroll)`
       a secas: ahí page-wrapper sí es el scroller y funciona.) */
    function getMY() {
      if (_pwScroll && _pwScroll.scrollHeight > _pwScroll.clientHeight) {
        return _pwScroll.scrollTop || 0;
      }
      return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function hideMobileBar() {
      if (mBarHidden) return;
      mBarHidden = true;
      mobileTopbar.classList.add('is-hidden');
      /* El buscador sube a top:0 sincronizado con el topbar (misma curva) */
      if (mobileSearch) mobileSearch.classList.add('search-at-top');
    }

    function showMobileBar() {
      if (!mBarHidden) return;
      mBarHidden = false;
      mobileTopbar.classList.remove('is-hidden');
      /* El buscador vuelve a top:56px */
      if (mobileSearch) mobileSearch.classList.remove('search-at-top');
    }

    function onMobileScroll() {
      /* Solo actuar en breakpoint mobile */
      if (window.innerWidth >= 990) { mTicking = false; return; }
      var y = getMY();
      if (y <= 8)          { showMobileBar(); }
      else if (y > mLastY) { hideMobileBar(); }
      mLastY   = y;
      mTicking = false;
    }

    /* O7: dos registros, no cinco. Un scroll del documento ya llega a
       window, así que document, document.body y document.documentElement
       eran redundantes. Y van por on(): antes usaban addEventListener
       directo, así que quedaban fuera del AbortController y sobrevivían a
       cada re-inicialización. */
    function onScrollTick() {
      if (!mTicking) { requestAnimationFrame(onMobileScroll); mTicking = true; }
    }
    on(window, 'scroll', onScrollTick, { passive: true });
    if (_pwScroll) on(_pwScroll, 'scroll', onScrollTick, { passive: true });

    /* Estado inicial */
    onMobileScroll();
  }

  /* ─── Dropdown F1 ───────────────────────────────────────── */
  var navItems = document.querySelectorAll('.vxh-nav > li');
  navItems.forEach(function (li) {
    var btn = li.querySelector('[aria-haspopup]');
    if (!btn) return;
    /* B7: pointerenter/leave con guard de táctil, igual que F2. Con
       mouseenter, en un laptop táctil un tap abría por hover y el click
       inmediato lo volvía a cerrar. En táctil manda solo el click. */
    li.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      li.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    });
    li.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      li.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = li.classList.contains('is-open');
      /* Cerrar los demás dejando su aria-expanded coherente: el toggle por
         click no lo tocaba, así que quedaba mintiendo tras un tap. */
      navItems.forEach(function (i) {
        i.classList.remove('is-open');
        var b = i.querySelector('[aria-haspopup]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        li.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    /* Cierre por Escape */
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        li.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  });

  function closeNavDropdownOnOutsideClick(e) {
    if (!navItems.length) return;
    /* Early exit: si ninguno está abierto no hace falta iterar */
    if (!document.querySelector('.vxh-nav > li.is-open')) return;
    if (!e.target.closest('.vxh-nav')) {
      navItems.forEach(function (i) { i.classList.remove('is-open'); });
    }
  }

  /* ─── Megamenú F2 ───────────────────────────────────────────
     FIX BUG #1: la lógica anterior usaba un closeTimer compartido
     entre f2El y megaEl con mouseenter/mouseleave. En sesiones
     normales (con caché) el mega quedaba pegado en mega-open.

     Nueva lógica:
     1. pointerenter en cualquier .vxh-f2-item → abre el mega
        y activa el grupo correspondiente.
     2. pointerleave en el CONTENEDOR f2El → verifica si el
        relatedTarget está dentro de f2El. Si no lo está, cierra.
        Esto es robusto contra movimientos rápidos de cursor.
     3. focusout en f2El → misma verificación con relatedTarget.
     4. Escape desde cualquier foco dentro de f2El → cierra.
     5. Click externo → cierra via closeMegaOnOutsideClick.
     ─────────────────────────────────────────────────────────── */
  var f2El       = document.getElementById('vxh-f2');
  var megaEl     = document.getElementById('vxh-f2-mega');
  var megaGroups = document.querySelectorAll('.vxh-mega-group');
  var f2Items    = document.querySelectorAll('.vxh-f2-item');
  var megaCaret  = document.getElementById('vxh-f2-mega-caret');
  var megaCaretTurnTimer = null;

  /* F2 y los títulos del mega menu usan tipografías distintas (F2:
     texto normal; título del mega menu: mayúsculas + letter-spacing),
     así que el mismo texto ocupa un ancho distinto en cada uno -- por
     CSS puro nunca coinciden exactamente. Se mide el ancho real
     (getBoundingClientRect) de cada item de F2 y se aplica ESE mismo
     ancho a su columna correspondiente, para que ambos ocupen
     exactamente el mismo espacio horizontal sin importar la tipografía. */
  function alignMegaColumnsToF2() {
    f2Items.forEach(function (item) {
      var groupId = item.getAttribute('data-group-id');
      if (!groupId) return;
      var group = document.getElementById(groupId);
      if (!group) return;
      var w = item.getBoundingClientRect().width;
      if (w > 0) {
        group.style.width = w + 'px';
      }
    });
  }
  /* F2 ahora está centrado (justify-content:center dentro de su propio
     max-width) -- el grupo de categorías ocupa solo su ancho natural,
     no el ancho completo del contenedor. La grilla del mega menú, en
     cambio, reservaba ese ancho completo para su columna central sin
     importar cuánto ocupaba F2 en la práctica. Acá se mide el ancho
     real del grupo (de la primera a la última categoría) y se aplica
     ESE número directo a la columna central de la grilla -- así las
     categorías del mega menú ocupan exactamente lo mismo que F2, y lo
     que sobra a los costados (más que antes) queda libre para las
     tarjetas de producto. */
  function alignMegaCategoriesWidthToF2() {
    if (!f2Items.length) return;
    var megaInner = document.querySelector('.vxh-f2-mega-inner');
    var megaCols = document.querySelector('.vxh-f2-mega-cols');
    if (!megaInner || !megaCols) return;
    var first = f2Items[0].getBoundingClientRect();
    var last = f2Items[f2Items.length - 1].getBoundingClientRect();
    var totalWidth = last.right - first.left;
    if (totalWidth <= 0) return;
    /* .vxh-f2-mega-cols tiene su propio padding interno (izquierda y
       derecha) -- sin sumarlo, ese padding le come espacio de sobra al
       ancho medido y las últimas categorías se caen a una fila nueva.
       Se lee el padding real ya calculado por el navegador (no se
       asume el número, por si el CSS cambia más adelante) y se suma
       al ancho antes de aplicarlo a la columna de la grilla. */
    var colsStyle = getComputedStyle(megaCols);
    var padLeft = parseFloat(colsStyle.paddingLeft) || 0;
    var padRight = parseFloat(colsStyle.paddingRight) || 0;
    var trackWidth = totalWidth + padLeft + padRight;
    megaInner.style.gridTemplateColumns =
      'minmax(0,1fr) ' + trackWidth + 'px minmax(0,1fr)';
  }
  on(window, 'load', alignMegaColumnsToF2);
  on(window, 'resize', alignMegaColumnsToF2);
  on(window, 'load', alignMegaCategoriesWidthToF2);
  on(window, 'resize', alignMegaCategoriesWidthToF2);
  /* Por si las fuentes tardan en cargar y el ancho medido al principio
     no era el final -- se vuelve a medir una vez más después de un
     instante, sin quedar en un loop ni depender de un evento especial. */
  setTimeout(alignMegaColumnsToF2, 400);
  setTimeout(alignMegaCategoriesWidthToF2, 400);

  /* Única fuente de verdad para "cuál categoría está activa" -- antes
     había dos caminos separados (uno para F2→mega, otro para
     mega→F2) que podían quedar desincronizados entre sí (ej. el
     subrayado de una categoría vieja no se apagaba al pasar a otra).
     Ahora los dos sentidos pasan siempre por esta misma función. */
  function setActiveGroup(groupId) {
    /* Si el grupo al que estamos "entrando" ya era el activo (reingreso
       al mismo, no cambio real), no corresponde girar de nuevo -- se
       chequea ANTES de tocar las clases is-active de abajo. */
    var wasAlreadyActive = false;
    f2Items.forEach(function (item) {
      if (item.getAttribute('data-group-id') === groupId && item.classList.contains('is-active')) {
        wasAlreadyActive = true;
      }
    });
    megaGroups.forEach(function (g) {
      g.classList.toggle('is-active', g.id === groupId);
    });
    f2Items.forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-group-id') === groupId);
    });
    /* Conector: reposicionarlo sobre la pestaña F2 activa cada vez
       que cambia el grupo activo -- mismo punto de entrada tanto si
       el hover viene de F2 como si viene de la propia columna. */
    if (megaCaret) {
      var activeItem = null;
      f2Items.forEach(function (item) {
        if (item.getAttribute('data-group-id') === groupId) activeItem = item;
      });
      if (activeItem) {
        var r = activeItem.getBoundingClientRect();
        var newLeft = r.left + r.width / 2 - 12;
        if (!wasAlreadyActive) {
          var prevLeft = parseFloat(megaCaret.style.left);
          var movingLeft = !isNaN(prevLeft) && newLeft < prevLeft;
          megaCaret.classList.remove('is-turning-right', 'is-turning-left');
          megaCaret.classList.add(movingLeft ? 'is-turning-left' : 'is-turning-right');
          clearTimeout(megaCaretTurnTimer);
          megaCaretTurnTimer = setTimeout(function () {
            megaCaret.classList.remove('is-turning-right', 'is-turning-left');
          }, 450);
        }
        megaCaret.style.left = newLeft + 'px';
        megaCaret.classList.add('is-visible');
      } else {
        megaCaret.classList.remove('is-visible');
        megaCaret.classList.remove('is-turning-right', 'is-turning-left');
        clearTimeout(megaCaretTurnTimer);
      }
    }
  }

  function openMega(groupId) {
    if (!f2El || !megaEl) return;
    var yaAbierto = megaEl.classList.contains('is-open');

    /* O5: el trabajo caro corre solo al ABRIR, no en cada pointerenter
       de cada pestaña con el menú ya abierto. Recalcular al abrir sigue
       siendo obligatorio, y no solo en load/resize: si la fuente Archivo
       terminó de intercambiarse (font-display:swap), o si el editor de
       temas cambió un font-size/padding sin recargar la página, las
       medidas de load/resize ya quedaron obsoletas. */
    if (!yaAbierto) {
      alignMegaColumnsToF2();
      alignMegaCategoriesWidthToF2();
    }

    /* Esto sí en cada llamada: es una sola lectura, y mantiene el panel
       pegado a F2 aunque el header haya colapsado por el scroll. */
    megaEl.style.top = f2El.getBoundingClientRect().bottom + 'px';
    megaEl.classList.add('is-open');

    /* Las tarjetas destacadas (con sus widgets de Judge.me) viven ocultas
       (display:none via CSS) hasta este momento -- si el escaneo inicial
       de Judge.me pasó de largo por estar ocultas, este es el momento de
       forzar que las tome. Viven FUERA de .vxh-f2-mega-cols, o sea que son
       las mismas para todos los grupos: basta con escanear al abrir.
       batchRenderBadges() re-escanea el documento entero, así que repetirlo
       en cada cambio de pestaña era el costo más alto de esta función. */
    if (!yaAbierto) refreshReviewWidgets();

    setActiveGroup(groupId);
  }

  function closeMega() {
    if (!megaEl) return;
    megaEl.classList.remove('is-open');
    setActiveGroup('');
  }

  /* Viceversa: pasar el cursor por una columna del mega menu también
     subraya el item de F2 que le corresponde (mismo id ↔ data-group-id
     que ya conecta openMega con .vxh-mega-group). Si el usuario mueve
     el mouse a una columna distinta a la que abrió el menú, el
     subrayado en F2 se mueve para seguirla -- pasa por la misma
     setActiveGroup, así nunca queda una categoría vieja marcada. */
  megaGroups.forEach(function (g) {
    g.addEventListener('pointerenter', function () {
      setActiveGroup(g.id);
    });
  });

  if (f2El && megaEl) {
    /* Apertura al entrar en un item */
    f2Items.forEach(function (item) {
      item.addEventListener('pointerenter', function () {
        openMega(item.getAttribute('data-group-id') || '');
      });
    });

    /* B6: apertura por teclado. Complemento del focusout que ya existía
       más abajo — estaba escrita la mitad que cierra, faltaba la que abre.
       Sin esto .vxh-f2-mega es display:none, sus hijos no son focusables y
       las subcategorías no se alcanzaban con Tab. */
    f2El.addEventListener('focusin', function (e) {
      var item = e.target.closest && e.target.closest('.vxh-f2-item');
      if (item) openMega(item.getAttribute('data-group-id') || '');
    });

    /* Cierre al salir de F2 — verificar que no vamos al megaEl */
    f2El.addEventListener('pointerleave', function (e) {
      if (e.relatedTarget && (f2El.contains(e.relatedTarget) || megaEl.contains(e.relatedTarget))) return;
      closeMega();
    });

    /* Cierre al salir del megaEl */
    megaEl.addEventListener('pointerleave', function (e) {
      if (e.relatedTarget && (f2El.contains(e.relatedTarget) || megaEl.contains(e.relatedTarget))) return;
      closeMega();
    });

    /* Cierre por teclado */
    f2El.addEventListener('focusout', function (e) {
      if (e.relatedTarget && (f2El.contains(e.relatedTarget) || megaEl.contains(e.relatedTarget))) return;
      closeMega();
    });
    f2El.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMega();
    });
  }

  function closeMegaOnOutsideClick(e) {
    if (!megaEl || !megaEl.classList.contains('is-open')) return;
    if (!f2El.contains(e.target) && !megaEl.contains(e.target)) closeMega();
  }

  /* ─── Reset tras bfcache (pageshow) ─────────────
     Horizon usa cross-document view transitions: al volver con
     el botón Atrás, el navegador puede restaurar la página desde
     bfcache SIN re-ejecutar este script. Si el F1 o el megamenú
     F2 quedaron abiertos al momento de navegar, la clase is-open
     persiste congelada y el menú aparece "pegado" abierto al
     volver. Mismo patrón que ya usa cart-icon.js del tema base.
     ───────────────────────────────────────────── */
  on(window, 'pageshow', function (e) {
    if (!e.persisted) return;
    navItems.forEach(function (li) {
      li.classList.remove('is-open');
      var btn = li.querySelector('[aria-haspopup]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    closeMega();
  });

  /* ─── Scroll desktop: animar el header-wrap ────────────────
     En lugar de mover F1 y F2 por separado con position:fixed,
     el wrap completo sube con translateY igual a la altura de F1.
     F2 queda visible en top:0 del header-section automáticamente.
     Sin position:fixed, sin @keyframes, sin pre-pin.
     La transición CSS del wrap (0.34s) lo hace todo.
     ─────────────────────────────────────────────────────────── */
  var f1El   = document.getElementById('vxh-f1');
  var wrapEl = document.getElementById('vxh-header-wrap');

  if (f1El && wrapEl) {
    var isScrolled = false;
    var ticking    = false;

    function getScrollY() {
      if (_pwScroll) return _pwScroll.scrollTop;
      return window.scrollY || window.pageYOffset ||
             document.documentElement.scrollTop ||
             document.body.scrollTop || 0;
    }

    /* Altura de F1 cacheada. onScroll la leía con offsetHeight en CADA frame,
       forzando un layout síncrono justo mientras el wrap anima su transform:
       la receta clásica del scroll con tirones. Se recalcula solo acá, que
       corre al inicio, en cada resize y al entrar en estado scrolled. */
    var _f1H = 0;

    function applyWrapState() {
      _f1H = f1El.offsetHeight;
      /* Actualizar la variable CSS con la altura real de F1 */
      wrapEl.style.setProperty('--vxh-f1-total', _f1H + 'px');
    }

    function scrollHeader() {
      if (isScrolled) return;
      isScrolled = true;
      applyWrapState();
      /* Spacer NO cambia — el contenido nunca se mueve.
         El header es position:fixed, flota encima y sube solo */
      wrapEl.classList.add('vxh-wrap--scrolled');
    }

    function unscrollHeader() {
      if (!isScrolled) return;
      isScrolled = false;
      /* Spacer NO cambia — el contenido tampoco se mueve al volver */
      wrapEl.classList.remove('vxh-wrap--scrolled');
    }

    function onScroll() {
      var y   = getScrollY();
      /* sin lecturas de layout acá: se usa la altura cacheada */
      if (y > _f1H + 40 && !isScrolled)      { scrollHeader();   }
      else if (y < _f1H - 20 && isScrolled)  { unscrollHeader(); }
      /* Cerrar megamenú al hacer scroll para evitar desincronización */
      if (megaEl && megaEl.classList.contains('is-open')) { closeMega(); }
      ticking = false;
    }

    /* Inicializar la variable CSS */
    applyWrapState();
    var _wrapResizeT;
    on(window, 'resize', function () {
      clearTimeout(_wrapResizeT);
      _wrapResizeT = setTimeout(applyWrapState, 100);
    }, { passive: true });

    /* Solo escuchar en page-wrapper (confirmado como scroll container) */
    if (_pwScroll) {
      on(_pwScroll, 'scroll', function () {
        if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
      }, { passive: true });
    } else {
      on(window, 'scroll', function () {
        if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
      }, { passive: true });
    }

    onScroll();
  }

  /* ─── Buscador ──────────────────────────────────────────────
     FIX WARN #1: outsideClickClosers se reinicia antes de cada
     initSearchInstance para evitar acumulación de closures en
     re-renders del editor de Shopify.
     ─────────────────────────────────────────────────────────── */
  var outsideClickClosers = [];

  /* ── Historial de búsquedas recientes ─────────────────────── */
  var HISTORY_KEY = 'vxh_search_history';
  var HISTORY_MAX = 5;
  function getHistory() {
    try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch(e) { return []; }
  }
  function saveHistory(q) {
    var h = getHistory().filter(function(x){ return x !== q; });
    h.unshift(q);
    if (h.length > HISTORY_MAX) h = h.slice(0, HISTORY_MAX);
    try { localStorage.setItem(HISTORY_KEY, JSON.stringify(h)); } catch(e) {}
  }
  function clearHistory() { try { localStorage.removeItem(HISTORY_KEY); } catch(e) {} }

  /* ── Normalizar query ─────────────────────────────────────── */
  function normalizeQuery(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  }

  /* ── Stemming básico en español ───────────────────────────────
     Reduce palabras a su raíz para que mesa/mesas, plano/planos,
     soldador/soldadores hagan match sin importar el plural */
  function stem(word) {
    if (word.length <= 3) return word;
    /* Quitar sufijos comunes en orden de longitud */
    var suffixes = ['adores', 'iones', 'oras', 'ores', 'ados', 'idas',
                    'cion', 'dor', 'ion', 'es', 's'];
    for (var i = 0; i < suffixes.length; i++) {
      var s = suffixes[i];
      if (word.length > s.length + 2 && word.endsWith(s)) {
        return word.slice(0, -s.length);
      }
    }
    return word;
  }

  /* Normalizar y stemizar un texto completo */
  function stemText(text) {
    return normalizeQuery(text)
      .split(/\s+/)
      .filter(function(w){ return w.length > 0; })
      .map(stem)
      .join(' ');
  }

  /* ── Búsqueda tolerante a errores ────────────────────────── */
  function buildFuzzyQuery(q) {
    var norm = normalizeQuery(q);
    var words = norm.split(/\s+/).filter(function(w){ return w.length > 0; });
    /* Para cada palabra de 4+ chars, agregar variante sin primera letra
       "mesa de solda" → "mesa OR esa de solda OR olda"
       Shopify busca productos que contengan CUALQUIERA de los términos */
    var parts = [];
    words.forEach(function(w) {
      parts.push(w);
      if (w.length >= 4) parts.push(w.slice(1));
    });
    return parts.join(' ');
  }


  /* ── Sinónimos para búsqueda semántica local ───────────────── */
  var SYNONYMS = {
    'gym':        ['gimnasio', 'gym'],
    'gimnasio':   ['gimnasio', 'gym'],
    'solda':      ['soldadura', 'soldador', 'solda'],
    'weld':       ['soldadura', 'soldador'],
    'cnc':        ['cnc', 'fresadora', 'router'],
    'laser':      ['laser', 'corte'],
    'mesa':       ['mesa', 'table'],
    'sujecion':   ['sujecion', 'fijacion', 'clamp'],
    'sujec':      ['sujecion', 'fijacion'],
    'maquina':    ['maquina', 'machine'],
    'tool':       ['herramienta', 'tool'],
    'parrilla':   ['parrilla', 'grill', 'asador'],
    'grill':      ['parrilla', 'grill', 'asador'],
    'torno':      ['torno', 'lathe'],
    'plasma':     ['plasma', 'corte'],
    'dxf':        ['dxf', 'planos', 'corte'],
    'pdf':        ['pdf', 'planos'],
    'plano':      ['planos', 'plano'],
    'plan':       ['planos', 'plano', 'plan'],
    'kit':        ['kit', 'completo', 'set'],
    'bench':      ['mesa', 'banco'],
    'acero':      ['acero', 'steel', 'metal'],
    'steel':      ['acero', 'steel', 'metal'],
    'metal':      ['metal', 'acero', 'metalico'],
    'celosia':    ['celosia', 'enrejado', 'malla'],
    'mueble':     ['mueble', 'furniture'],
    'tronzadora': ['tronzadora', 'sierra', 'corte'],
    'sierra':     ['sierra', 'tronzadora', 'corte'],
    'pedestal':   ['pedestal', 'base', 'soporte'],
    'extension':  ['extension', 'ampliacion'],
    'fogon':      ['fogon', 'cocina', 'fuego'],
    'cohete':     ['cohete', 'rocket', 'fogon']
  };

  /* ── Control global de scroll lock ─────────────────────────
     Contador de paneles abiertos — evita que la instancia mobile
     desbloquee el scroll cuando la desktop está abierta */
  /* overflow:hidden solo no basta en iOS Safari — el touchmove
     puede seguir arrastrando el fondo. Bloqueamos el gesto salvo
     que empiece dentro del propio buscador. */
  function vxhPreventTouchScroll(e) {
    if (e.target.closest('.vxh-search-results, .vxh-search')) return;
    e.preventDefault();
  }
  function vxhLockScroll()   {
    document.documentElement.classList.add('vxh-search-open');
    document.addEventListener('touchmove', vxhPreventTouchScroll, { passive: false });
  }
  function vxhUnlockScroll() {
    /* Verifica el DOM en vez de un contador manual: no puede
       quedar desincronizado entre la instancia desktop y mobile. */
    if (document.querySelector('.vxh-search-results.is-open')) return;
    document.documentElement.classList.remove('vxh-search-open');
    document.removeEventListener('touchmove', vxhPreventTouchScroll, { passive: false });
  }

  /* ── Índice local de productos para búsqueda fuzzy ───────────
     Se pre-carga una vez al iniciar la página desde /search/suggest.json
     con una query vacía especial. El índice permite buscar por tokens
     parciales sin importar el orden de las palabras ni tildes.

     FIX B1: vive en el scope del IIFE, no dentro de initSearchInstance.
     Antes scheduleIndex() lo referenciaba desde fuera → ReferenceError,
     y cada instancia (desktop + mobile) construía su propia copia del
     índice (O6). */
  var _searchIndex = null;
  var _indexLoading = false;

  function buildIndex() {
    if (_searchIndex || _indexLoading) return;
    _indexLoading = true;

    /* Intentar leer del sessionStorage primero (0ms de red) */
    try {
      var cached = sessionStorage.getItem('vxh_product_index_v4');
      if (cached) {
        _searchIndex = JSON.parse(cached);
        _indexLoading = false;
        return;
      }
    } catch(e) {}

    /* Fetch con cache del browser (force-cache reutiliza respuestas cacheadas) */
    fetch('/products.json?limit=250', { cache: 'force-cache' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products || [];
        _searchIndex = products.map(function(p) {
          /* La primera variante disponible, la que pinta la ficha. Con
             variants[0], un producto con la primera agotada salía en el
             buscador con un precio que la ficha no muestra. */
          var variant = null;
          if (p.variants && p.variants.length) {
            variant = p.variants[0];
            for (var vi = 0; vi < p.variants.length; vi++) {
              if (p.variants[vi].available) { variant = p.variants[vi]; break; }
            }
          }
          var price   = variant ? parseFloat(variant.price) : null;
          var compare = variant && variant.compare_at_price
                      ? parseFloat(variant.compare_at_price) : null;
          var imgObj  = p.featured_image || (p.images && p.images[0]) || null;
          var imgSrc  = imgObj && imgObj.src ? imgObj.src.split('?')[0] : '';
          return {
            p: {
              id:               p.id,
              title:            p.title,
              url:              '/products/' + p.handle,
              vendor:           p.vendor,
              tags:             p.tags || [],
              price:            price,
              compare_at_price: compare,
              featured_image:   imgSrc || null
            },
            t: stemText([
              p.title  || '',
              p.vendor || '',
              (p.tags  || []).join(' ')
            ].join(' '))
          };
        });
        /* Guardar en sessionStorage para la sesión actual. La versión de la
           clave sube cada vez que cambia la FORMA del objeto guardado (v3
           agregó `id`): si no, quien tenga sesión abierta seguiría leyendo
           un índice viejo al que le faltan campos. */
        try { sessionStorage.setItem('vxh_product_index_v4', JSON.stringify(_searchIndex)); } catch(e) {}
        _indexLoading = false;
      })
      .catch(function() { _indexLoading = false; });
  }

  /* Busca en índice local con soporte de sinónimos.
     "gym" → busca "gimnasio" OR "gym" en el texto normalizado */
  function searchLocal(q) {
    if (!_searchIndex) return null;
    var tokens = normalizeQuery(q).split(/\s+/).filter(function(t) { return t.length > 0; });
    if (!tokens.length) return [];

    return _searchIndex.filter(function(entry) {
      return tokens.every(function(token) {
        var stemmed = stem(token);
        /* Buscar con sinónimos (también stemizados) y con la raíz del token */
        var candidates = SYNONYMS[token]
          ? SYNONYMS[token].map(stem).concat([stemmed])
          : [stemmed, token]; /* probar raíz y original */
        return candidates.some(function(candidate) {
          return entry.t.indexOf(candidate) > -1;
        });
      });
    }).slice(0, 6).map(function(entry) { return entry.p; });
  }

  function initSearchInstance(wrapEl) {
    var searchInput   = wrapEl.querySelector('.vxh-q');
    var searchResults = wrapEl.querySelector('.vxh-search-results');
    var clearBtn      = wrapEl.querySelector('.vxh-search-clear');
    var searchForm    = wrapEl.querySelector('.vxh-search-box');
    if (!searchInput || !searchResults) return;

    /* La búsqueda solo debe pasar por el cuadro desplegable, nunca por
       la página nativa de resultados de Horizon -- se previene el
       envío del formulario acá (cubre Enter en el campo, no solo el
       clic en la lupa, que ya se cambió a type="button"). */
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) { e.preventDefault(); });
    }

    var debounceTimer, currentQuery = '';
    var isMobile = searchResults.classList.contains('vxh-search-results-m');
    var abortCtrl = null;

    /* Posicionamiento del panel desktop */
    function positionPanel() {
      if (isMobile) return;
      var rect   = searchInput.getBoundingClientRect();
      var panelW = Math.min(760, window.innerWidth - 32);
      var left   = rect.left;
      if (left + panelW > window.innerWidth - 16) left = window.innerWidth - panelW - 16;
      searchResults.style.top   = (rect.bottom + 6) + 'px';
      searchResults.style.left  = left + 'px';
      searchResults.style.width = panelW + 'px';
    }

    /* ── B6 · ARIA y navegación con teclado del panel ────────────
       El panel declaraba role="listbox" pero sus hijos no eran opciones,
       y el input pedía aria-autocomplete sin ser combobox. Acá se corrige
       el árbol: los títulos pasan a presentation, las columnas a group y
       lo seleccionable a option. Sobre esa lista se navega con ↑/↓. */
    var _opciones = [], _optActiva = -1, _optSeq = 0;

    function limpiarOpcionActiva() {
      if (_optActiva > -1 && _opciones[_optActiva]) {
        _opciones[_optActiva].classList.remove('is-active-option');
        _opciones[_optActiva].setAttribute('aria-selected', 'false');
      }
      _optActiva = -1;
      searchInput.removeAttribute('aria-activedescendant');
    }

    function etiquetarPanel() {
      searchResults.querySelectorAll('.vxh-sr-col-title').forEach(function (el) {
        el.setAttribute('role', 'presentation');
      });
      searchResults.querySelectorAll('.vxh-sr-left, .vxh-sr-right').forEach(function (el) {
        el.setAttribute('role', 'group');
      });
      var sel = '.vxh-sr-product, .vxh-sr-history-item, .vxh-sr-suggestion, .vxh-sr-viewall';
      searchResults.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute('role', 'option');
        el.setAttribute('aria-selected', 'false');
        if (!el.id) el.id = 'vxh-opt-' + (++_optSeq);
      });
      _opciones = Array.prototype.slice.call(searchResults.querySelectorAll('[role="option"]'));
      limpiarOpcionActiva();
    }

    function moverOpcion(paso) {
      if (!_opciones.length) return;
      var anterior = _optActiva;
      if (anterior > -1 && _opciones[anterior]) {
        _opciones[anterior].classList.remove('is-active-option');
        _opciones[anterior].setAttribute('aria-selected', 'false');
      }
      _optActiva = (anterior + paso + _opciones.length) % _opciones.length;
      var el = _opciones[_optActiva];
      el.classList.add('is-active-option');
      el.setAttribute('aria-selected', 'true');
      searchInput.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function openPanel() {
      positionPanel();
      if (!searchResults.classList.contains('is-open')) {
        searchResults.classList.add('is-open');
        vxhLockScroll();
      }
      searchInput.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      if (searchResults.classList.contains('is-open')) {
        searchResults.classList.remove('is-open');
        vxhUnlockScroll();
      }
      searchInput.setAttribute('aria-expanded', 'false');
      limpiarOpcionActiva();
    }

    /* Panel inicial: recientes o populares + productos destacados */
    function showInitialPanel() {
      var history    = getHistory();
      var catTpl     = document.getElementById('vxh-search-cats');
      var popularTpl = document.getElementById('vxh-search-popular');
      var featTpl    = document.getElementById('vxh-search-featured');

      /* Panel izquierdo: categorías (solo desktop) */
      var left = '';
      if (!isMobile && catTpl) {
        left = '<div class="vxh-sr-left"><div class="vxh-sr-col-title">Categorías</div>';
        catTpl.content.querySelectorAll('a').forEach(function(a) {
          left += '<a href="' + a.getAttribute('href') + '" class="vxh-sr-suggestion">' + escHtml(a.textContent.trim()) + '</a>';
        });
        left += '</div>';
      }

      var right = '<div class="vxh-sr-right">';

      /* Búsquedas recientes */
      if (history.length > 0) {
        right += '<div class="vxh-sr-col-title vxh-sr-col-title--flex">'
               + 'Búsquedas recientes'
               + '<button class="vxh-sr-clear-history">Borrar</button>'
               + '</div>';
        history.forEach(function(h) {
          right += '<button class="vxh-sr-history-item" data-q="' + escHtml(h) + '">'
                 + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
                 + escHtml(h) + '</button>';
        });
        right += '<div style="height:12px;"></div>';
      }

      /* Búsquedas populares del editor */
      var popularItems = popularTpl ? Array.from(popularTpl.content.querySelectorAll('span')) : [];
      if (popularItems.length > 0) {
        right += '<div class="vxh-sr-col-title">Búsquedas populares</div>';
        popularItems.forEach(function(span) {
          var txt = span.textContent.trim();
          if (!txt) return;
          right += '<button class="vxh-sr-history-item" data-q="' + escHtml(txt) + '">'
                 + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/></svg>'
                 + escHtml(txt) + '</button>';
        });
      }

      /* Productos populares del editor */
      var featItems = featTpl ? Array.from(featTpl.content.querySelectorAll('a')) : [];
      if (featItems.length > 0) {
        right += '<div class="vxh-sr-col-title" style="margin-top:12px;">Productos populares</div>';
        featItems.forEach(function(a) {
          var title   = a.getAttribute('data-title') || '';
          var price   = a.getAttribute('data-price');
          var compare = a.getAttribute('data-compare');
          var img     = a.getAttribute('data-img') || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          var href    = a.getAttribute('href') || '#';
          var tags    = a.getAttribute('data-tags') || '';
          var pid     = a.getAttribute('data-id') || '';
          var formats = extractFormats(tags);
          var isFis   = hasTag(tags, 'producto-fisico');
          var badge   = isFis
            ? '<span class="vxh-sr-product-badge vxh-sr-badge--fisico">Físico</span>'
            : '<span class="vxh-sr-product-badge vxh-sr-badge--planos">Planos</span>';
          var imgTag  = img
            ? '<img class="vxh-sr-product-img" src="' + img + '" alt="' + escHtml(title) + '" loading="lazy" width="76" height="76">'
            : '<div class="vxh-sr-product-img"></div>';
          var fmtsTag = formats.length
            ? '<span class="vxh-sr-formats">' + formats.slice(0, 3).map(function(f) { return '<span class="vxh-sr-fmt">' + escHtml(f) + '</span>'; }).join('') + '</span>'
            : '';
          var badgeSrc = a.querySelector('.vxh-sf-badge-src');
          var badgeHtml = badgeSrc ? badgeSrc.innerHTML : '';
          var starsTag = pid
            ? '<div class="jdgm-widget jdgm-preview-badge vxh-sr-stars" data-id="' + pid + '" data-judgeme-id="' + pid + '">' + badgeHtml + '</div>'
            : '';
          var priceHtml = '';
          if (price) {
            var n = parseFloat(price);
            var c = parseFloat(compare);
            var hasD = c && c > n;
            priceHtml = '<div class="vxh-sr-product-price">' + fmtMoney(n)
                      + (hasD ? ' <span class="vxh-sr-price-compare">' + fmtMoney(c) + '</span>' : '')
                      + '</div>';
          }
          right += '<a href="' + href + '" class="vxh-sr-product" data-vxh-result>'
                 + '<div class="vxh-sr-product-media">' + imgTag + fmtsTag + '</div>'
                 + '<div class="vxh-sr-product-info">' + badge
                 + '<div class="vxh-sr-product-title">' + escHtml(title) + '</div>'
                 + starsTag
                 + priceHtml + '</div></a>';
        });
      }

      right += '</div>';
      searchResults.innerHTML = left + right;
      etiquetarPanel();

      /* Listeners history items y búsquedas populares —
         al hacer clic: llenar el input, buscar y MANTENER panel abierto */
      searchResults.querySelectorAll('.vxh-sr-history-item').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation(); /* evitar que outsideClickClosers cierre el panel */
          var q = btn.getAttribute('data-q');
          searchInput.value = q;
          if (clearBtn) clearBtn.classList.add('is-visible');
          currentQuery = q;
          /* Mostrar loading y buscar — el panel permanece abierto */
          searchResults.innerHTML = isMobile
            ? '<div class="vxh-sr-loading">Buscando...</div>'
            : (left || '') + '<div class="vxh-sr-right"><div class="vxh-sr-loading">Buscando...</div></div>';
          fetchResults(q);
        });
      });

      /* Productos populares — navegar al producto cierra el panel */
      searchResults.addEventListener('click', function(e) {
        var result = e.target.closest('[data-vxh-result]');
        if (result) { closePanel(); }
      }, { once: true });

      /* Borrar historial */
      var clearH = searchResults.querySelector('.vxh-sr-clear-history');
      if (clearH) {
        clearH.addEventListener('click', function(e) {
          e.stopPropagation(); clearHistory(); showInitialPanel();
        });
      }
      refreshReviewWidgets();
      openPanel();
    }

    /* Input handler */
    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var q = searchInput.value.trim();
      if (clearBtn) clearBtn.classList.toggle('is-visible', q.length > 0);
      if (q.length === 0) { showInitialPanel(); return; }
      if (q.length < 2)  { closePanel(); searchResults.innerHTML = ''; return; }
      currentQuery = q;
      debounceTimer = setTimeout(function() {
        if (!searchResults.classList.contains('is-open')) openPanel();
        searchResults.innerHTML = '<div class="vxh-sr-loading">Buscando...</div>';
        fetchResults(q);
      }, 180);
    });

    /* Focus */
    searchInput.addEventListener('focus', function() {
      buildIndex(); /* Asegurar que el índice está listo */
      if (searchInput.value.trim().length >= 2 && searchResults.innerHTML) {
        openPanel();
      } else if (searchInput.value.trim().length < 2) {
        showInitialPanel();
      }
    });

    /* B6: Escape, flechas y Enter. Antes solo estaba Escape, así que los
       resultados no se podían recorrer sin mouse. */
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closePanel(); searchInput.blur(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!searchResults.classList.contains('is-open')) return;
        e.preventDefault();   /* que no mueva el cursor dentro del input */
        moverOpcion(e.key === 'ArrowDown' ? 1 : -1);
        return;
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        if (_optActiva > -1 && _opciones[_optActiva]) {
          _opciones[_optActiva].click();
          return;
        }
        /* Enter sin opción resaltada lleva al mismo sitio que «Ver todo».
           Antes no hacía nada: el envío del formulario está prevenido a
           propósito —la búsqueda vive en el desplegable— pero eso dejaba
           a Enter sin ninguna salida, que es justo lo que hace todo el
           mundo después de escribir. */
        var qEnter = searchInput.value.trim();
        if (qEnter) {
          window.location.href = '/search?q=' + encodeURIComponent(qEnter) + '&type=product';
        }
      }
    });

    /* Clear btn */
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        searchInput.value = '';
        clearBtn.classList.remove('is-visible');
        showInitialPanel();
        searchInput.focus();
      });
    }

    /* Resize */
    on(window, 'resize', function() {
      if (searchResults.classList.contains('is-open')) positionPanel();
    }, { passive: true });

    /* fetchResults: índice local primero (instantáneo), Shopify como respaldo */
    function fetchResults(q) {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var opts = abortCtrl ? { signal: abortCtrl.signal } : {};

      /* Si el índice no está listo aún, esperar hasta 2s y reintentar */
      if (!_searchIndex && _indexLoading) {
        var waited = 0;
        var waiter = setInterval(function() {
          waited += 100;
          if (_searchIndex) {
            clearInterval(waiter);
            if (q === currentQuery) fetchResults(q);
          } else if (waited >= 2000) {
            clearInterval(waiter);
          }
        }, 100);
        return;
      }

      /* Resultado local inmediato sin delay de red */
      var localResults = searchLocal(q);
      if (localResults && localResults.length > 0) {
        renderResults(localResults, [], q);
        return; /* Resultado local suficiente — no necesitamos Shopify */
      }

      /* Fallback a Shopify si no hay resultado local */
      if (!searchResults.innerHTML || searchResults.innerHTML.indexOf('vxh-sr-product') === -1) {
        searchResults.innerHTML = '<div class="vxh-sr-loading">Buscando...</div>';
      }
      fetch(
        '/search/suggest.json?q=' + encodeURIComponent(buildFuzzyQuery(q)) +
        '&resources[type]=product,query&resources[limit]=6' +
        '&resources[options][fields]=title,product_type,vendor,variants.title,tag',
        opts
      )
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (q !== currentQuery) return;
          var res = (data.resources && data.resources.results) || {};
          renderResults(res.products || [], res.queries || [], q);
        })
        .catch(function(err) {
          if (err && err.name === 'AbortError') return;
          if (q === currentQuery && (!localResults || !localResults.length)) {
            searchResults.innerHTML = '<div class="vxh-sr-empty">Sin resultados para "' + escHtml(q) + '"</div>';
          }
        });
    }

    function buildCatsLeft(q) {
      var catTpl = document.getElementById('vxh-search-cats');
      var html = '<div class="vxh-sr-left"><div class="vxh-sr-col-title">Categorías</div>';
      if (catTpl) {
        catTpl.content.querySelectorAll('a').forEach(function(a) {
          html += '<a href="' + a.getAttribute('href') + '" class="vxh-sr-suggestion">' + escHtml(a.textContent.trim()) + '</a>';
        });
      }
      html += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="vxh-sr-viewall">Ver todo: ' + escHtml(q) + '</a></div>';
      return html;
    }

    function renderResults(products, queries, q) {
      if (!products.length && !queries.length) {
        var emptyRight = '<div class="vxh-sr-right"><div class="vxh-sr-empty">Sin resultados para "' + escHtml(q) + '"</div></div>';
        searchResults.innerHTML = isMobile ? emptyRight : buildCatsLeft(q) + emptyRight;
        refreshReviewWidgets();
        return;
      }
      var left  = isMobile ? '' : buildCatsLeft(q);
      var right = '<div class="vxh-sr-right"><div class="vxh-sr-col-title">Productos</div>';
      products.forEach(function(p) {
        /* featured_image puede ser string (índice local) u objeto con .url (Shopify suggest) */
        var fi  = p.featured_image;
        var raw = typeof fi === 'string' ? fi
                : (fi && (fi.url || fi.src)) ? (fi.url || fi.src) : '';
        /* Asegurar que la URL tenga protocolo */
        if (raw && raw.indexOf('//') === 0) raw = 'https:' + raw;
        /* Limpiar parámetros existentes y agregar tamaño */
        var img = raw ? raw.split('?')[0] + '?width=128' : '';
        var imgTag = img
          ? '<img class="vxh-sr-product-img" src="' + img + '" alt="' + escHtml(p.title) + '" loading="lazy" width="76" height="76">'
          : '<div class="vxh-sr-product-img"></div>';
        var priceHtml = '';
        if (p.price) {
          /* Los dos caminos traen el precio de comparación con distinta forma:
             el índice local arma compare_at_price; /search/suggest.json no lo
             devuelve —usa compare_at_price_min/_max— y manda todo como string,
             así que sin parseFloat la comparación sería lexicográfica
             ("100.00" > "52.00" da false). */
          var precio  = parseFloat(p.price);
          var compara = NaN;
          var desde   = '';
          if (p.price_min == null) {
            /* Índice local: precio y tachado de la misma variante, la primera
               disponible (MONEDA.md §2.6). */
            compara = parseFloat(p.compare_at_price);
          } else if (p.price_min === p.price_max) {
            /* /search/suggest.json con un solo precio: el tachado mínimo es de
               una variante de ese mismo precio, así que el par es real. */
            compara = parseFloat(p.compare_at_price_min);
          } else {
            /* /search/suggest.json con precios distintos no deja elegir
               variante (variants llega vacío): price es el mínimo y
               compare_at_price_min puede ser de otra. Con el kit completo
               pintaba $34.00 con $46.00 tachado, pero el $34 es de la variante
               en inglés, que no tiene tachado, y el $46 de la española. Tampoco
               sirve buscar el par en el índice local: a veces el enlace lleva
               &variant= a una variante concreta, que no es la primera
               disponible. Así que sin tachado, y con «Desde», porque es el
               mínimo. MONEDA.md §5 y §10.2, punto 11. */
            desde = 'Desde ';
          }
          var hasDiscount = !isNaN(compara) && compara > precio;
          priceHtml = '<div class="vxh-sr-product-price">' + desde + fmtMoney(precio)
                    + (hasDiscount ? ' <span class="vxh-sr-price-compare">' + fmtMoney(compara) + '</span>' : '')
                    + '</div>';
        }
        var isFisico = hasTag(p.tags, 'producto-fisico');
        var badge    = isFisico
          ? '<span class="vxh-sr-product-badge vxh-sr-badge--fisico">Físico</span>'
          : '<span class="vxh-sr-product-badge vxh-sr-badge--planos">Planos</span>';
        var fmts2 = extractFormats(p.tags);
        var fmtsTag2 = fmts2.length
          ? '<span class="vxh-sr-formats">' + fmts2.slice(0, 3).map(function(f) { return '<span class="vxh-sr-fmt">' + escHtml(f) + '</span>'; }).join('') + '</span>'
          : '';
        var starsTag = p.id
          ? '<div class="jdgm-widget jdgm-preview-badge vxh-sr-stars" data-id="' + p.id + '" data-judgeme-id="' + p.id + '"></div>'
          : '';
        right += '<a href="' + p.url + '" class="vxh-sr-product" data-vxh-result>'
               + '<div class="vxh-sr-product-media">' + imgTag + fmtsTag2 + '</div>'
               + '<div class="vxh-sr-product-info">' + badge
               + '<div class="vxh-sr-product-title">' + escHtml(p.title) + '</div>'
               + starsTag
               + priceHtml + '</div></a>';
      });
      right += '</div>';
      searchResults.innerHTML = left + right;
      etiquetarPanel();
      refreshReviewWidgets();
    }

    /* Selección de un resultado: UN listener por instancia, no uno por render.
       renderResults lo registraba en cada render con {once:true}, y `once` solo
       lo quita cuando dispara: los de búsquedas anteriores quedaban colgados y,
       al hacer clic, cada uno guardaba SU término viejo en el historial.

       El término se lee del input en el momento del clic, no de una variable
       capturada. Así el panel inicial (input vacío) no guarda nada, que es lo
       correcto: ahí no hubo búsqueda. */
    searchResults.addEventListener('click', function (e) {
      if (!e.target.closest('[data-vxh-result]')) return;
      var elegida = searchInput.value.trim();
      if (elegida.length >= 2) saveHistory(elegida);
      closePanel();
    });

    outsideClickClosers.push(function(e) {
      if (!wrapEl.contains(e.target) && !searchResults.contains(e.target)) closePanel();
    });
  }

  /* Inicializar las dos instancias del buscador (desktop + mobile) */
  outsideClickClosers = [];
  document.querySelectorAll('.vxh-search').forEach(initSearchInstance);

  /* Pre-cargar índice con requestIdleCallback — no bloquea el render inicial.
     Fallback a setTimeout(500) si el browser no soporta rIC */
  function scheduleIndex() {
    if (window.requestIdleCallback) {
      requestIdleCallback(buildIndex, { timeout: 3000 });
    } else {
      setTimeout(buildIndex, 500);
    }
  }
  if (document.readyState === 'complete') {
    scheduleIndex();
  } else {
    on(window, 'load', scheduleIndex);
  }

  /* ─── Boton de cerrar buscador mobile ────────────
   No necesita cerrar el panel el mismo: al estar FUERA de
   wrapEl/searchResults, el click ya burbujea al listener
   global de abajo y outsideClickClosers lo cierra solo. Aca
   unicamente le sacamos el foco al input para bajar el teclado. */
  var vxhMobileSearchClose = document.getElementById('vxh-mobile-search-close');
  if (vxhMobileSearchClose) {
    vxhMobileSearchClose.addEventListener('click', function () {
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    });
  }

  /* ─── Cerrar el carrito al hacer clic afuera ───────────────
     En ≥990px Horizon abre el cart drawer con show(), o sea un dialog NO
     modal: sin backdrop. Por eso su #onBackdropClick queda inerte —lo dice
     su propio comentario— y el drawer solo cerraba con la X o Escape.

     Nativamente eso no molesta porque el drawer EMPUJA el contenido
     (.page-wrapper--drawer-open lleva margin-right), así que "afuera" sigue
     siendo página usable. Acá ese empuje está neutralizado a propósito y el
     drawer se superpone, así que sin esto se sentía atascado.

     En <990px el drawer sí es modal y el nativo ya lo maneja: por eso se sale
     temprano si el dialog está en modo modal, para no cerrar dos veces. */
  function closeCartDrawerOnOutsideClick(e) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return;
    var panel = drawer.querySelector('dialog');
    try { if (panel && panel.matches(':modal')) return; } catch (err) {}
    if (drawer.contains(e.target)) return;
    /* el propio disparador ya hace toggle; si no, se cerraría y reabriría */
    if (e.target.closest && e.target.closest('[aria-controls="cart-drawer"]')) return;
    if (typeof drawer.close === 'function') drawer.close();
  }

/* ─── Listener global de clicks ─────────────────────────── */
  on(document, 'click', function (e) {
    closeNavDropdownOnOutsideClick(e);
    closeMegaOnOutsideClick(e);
    closeCartDrawerOnOutsideClick(e);
    outsideClickClosers.forEach(function (fn) { fn(e); });
  });

  /* ─── Drawer mobile ─────────────────────────────────────── */
  var headerDrawer = document.getElementById('header-drawer');
  if (headerDrawer) {
    var openDrawerBtns = [
      document.getElementById('vxh-hamburger-top'),
      document.getElementById('vxh-menu-trigger')
    ];
    openDrawerBtns.forEach(function (btn) {
      if (btn) btn.addEventListener('click', function () { headerDrawer.showModal(); });
    });
    var closeDrawerBtn = document.getElementById('vxh-drawer-close');
    if (closeDrawerBtn) {
      closeDrawerBtn.addEventListener('click', function () { headerDrawer.close(); });
    }
    headerDrawer.addEventListener('click', function (e) {
      if (e.target === headerDrawer) headerDrawer.close();
    });
  }

  /* ─── Contador de wishlist ──────────────────────────────────
     El bucle, el listener de 'storage' y el de 'visibilitychange'
     viven en assets/vx-wishlist.js, que los comparte con las tarjetas
     y la ficha. Aca solo queda la primera pintura. */
  if (window.VXWish) VXWish.syncCount();

}

vxhInitHeader();

/* El editor de temas re-renderiza la sección al tocar un setting. Este
   listener NO se ata al AbortController: tiene que sobrevivir a los aborts,
   porque es justamente el que dispara la siguiente inicialización. */
document.addEventListener('shopify:section:load', function (e) {
  if (e.target && e.target.querySelector && e.target.querySelector('.vxh')) vxhInitHeader();
});
